import { useLogger } from '../../composables/useLogger'

const logger = useLogger()

/**

 * Process an array of items concurrently with a limited number of workers.
 * @param {Array} items - Array of items to process
 * @param {Function} processItem - Async function to process a single item and returns a promise that resolves 
 * to the processed item
 * @param {number} [concurrency=10] - Number of concurrent workers
 * @returns {Promise<Array>} Promise that resolves when all items are processed
 */
export async function processQueue(items, processItem, concurrency = 10) {
    if (!items || items.length === 0) {
        return []
    }
    try {
        const queue = [...items];
        const results = [];

        async function worker() {
            while (queue.length > 0) {
                const item = queue.shift();
                if (item !== undefined) {
                    const result = await processItem(item);
                    results.push(result);
                }
            }
        }
        const workers = Array(concurrency).fill(null).map(() => worker());
        await Promise.all(workers);

        return results;
    } catch (error) {
        logger.logErrorCaught('Error processing queue', 'Queue.js', error)
        throw error
    }
}